import keyBy from 'lodash/keyBy';
import { Currency } from '../../administration/clientAdministrationPage/types';
import Config from '../../config';
import { QueryKeys, useCustomQuery } from './index';

export type CurrencyCode = Pick<Currency, 'currencyCode'>;

export type TaxCurrencyDefaultCode = {
  countryCode: string,
  currencyCode: string,
}

export const useCurrenciesList = () => useCustomQuery<CurrencyCode[]>(
  [QueryKeys.currencies.CurrenciesList],
  {
    url: Config.endpoints.FETCH_CURRENCY_CODES_ENABLED,
    errorMessage: 'Fetching currencies failed',
    defaultData: [],
  }
);

export const useCurrenciesOptions = () => {
  const {
    data,
    ...options
  } = useCurrenciesList();

  return {
    data: data!.map(({ currencyCode }) => ({
      label: currencyCode,
      value: currencyCode,
    })),
    ...options,
  };
};


export const useTaxCurrencyDefaultCodes = () => {
  const {
    data,
    ...rest
  } = useCustomQuery<TaxCurrencyDefaultCode[]>(
    [QueryKeys.currencies.TaxCurrencyDefaultCodes],
    {
      url: Config.endpoints.FETCH_TAX_CURRENCY_DEFAULT_CODES_FOR_OBLIGATIONS,
      defaultData: [],
    }
  );

  return {
    data: keyBy(data, 'countryCode'),
    ...rest,
  };
};

export const useAdminCurrencies = () => useCustomQuery<Currency[]>(
  [QueryKeys.currencies.AdminCurrencies],
  {
    url: Config.endpoints.FETCH_ADMIN_CURRENCIES,
    errorMessage: 'Fetching currencies failed',
    defaultData: [],
  }
);

